import { RevenueReportTemplateDetailPage } from "@/features/revenue-report-template/pages/RevenueReportTemplateDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/admin/revenue-report-template/$id/detail",
)({
	validateSearch: (search: Record<string, unknown>): { tab?: string } => ({
		tab: typeof search.tab === "string" ? search.tab : undefined,
	}),
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["revenue_report_template.view"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: RevenueReportTemplateDetailPage,
});
